import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiGet, API_BASE_URL, logout as apiLogout } from "./api";

const AuthContext = createContext(null);

function storeTokenFromHashOnce() {
    const hash = window.location.hash || "";
    const prefix = "#auth_token=";
    if (hash.startsWith(prefix)) {
        const raw = hash.slice(prefix.length);
        const token = decodeURIComponent(raw);
        try {
            if (token) {
                localStorage.setItem("amnesia_auth_token", token);
            }
        } catch {}
        const cleanUrl = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", cleanUrl);
    }
}

export function AuthProvider({ children }) {
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadMe = useCallback(async () => {
        setLoading(true);
        try {
            const d = await apiGet("/me.php");
            console.log("[Auth] /me.php response:", d);
            setMe(d && d.user ? d.user : null);
        } catch (err) {
            console.error("[Auth] /me.php failed:", err);
            setMe(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        storeTokenFromHashOnce();
        loadMe();
    }, [loadMe]);

    const login = () => {
        window.location.href = `${API_BASE_URL}/auth_start.php`;
    };

    const logout = async () => {
        try {
            await apiLogout();
        } catch {}
        try {
            localStorage.removeItem("amnesia_auth_token");
        } catch {}
        setMe(null);
        window.location.href = "/";
    };

    return (
        <AuthContext.Provider value={{ me, loading, login, logout, reload: loadMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
